import i18n from "../i18n";

const getActiveLocale = () => i18n.resolvedLanguage || i18n.language || navigator.language;

const dateOnlyPattern = /^\d{4}-\d{2}-\d{2}$/;

const parseDate = (value: string) => {
    if (dateOnlyPattern.test(value)) {
        const [year, month, day] = value.split("-").map(Number);
        return new Date(year, month - 1, day);
    }

    return new Date(value);
};

const formatLocalizedDate = (value: string, options: Intl.DateTimeFormatOptions) => {
    const parsedDate = parseDate(value);

    if (!Number.isFinite(parsedDate.getTime())) {
        return value;
    }

    return new Intl.DateTimeFormat(getActiveLocale(), options).format(parsedDate);
};

const formatDate = (value: string) =>
    formatLocalizedDate(value, {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
    });

const formatShortDate = (value: string) =>
    formatLocalizedDate(value, {
        month: "short",
        day: "numeric",
    });

const formatNumber = (value: number) => new Intl.NumberFormat(getActiveLocale()).format(value);

const formatCurrency = (value: number) => {
    const fractionDigits = value > 0 && value < 0.01 ? 4 : 2;
    return new Intl.NumberFormat(getActiveLocale(), {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    }).format(value);
};

export const renderer = {
    formatLocalizedDate,
    formatDate,
    formatShortDate,
    formatNumber,
    formatCurrency,
};
